require('esn-frontend-common-libs/src/frontend/vendor-libs');
require('esn-frontend-mailto-handler/src/index.js');

require('./app/app');
require('./all.less');
